import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import AddAddressForm from '../AddAddressForm';
import { saveAddress } from '../../actions/address';
import * as addressReducer from '../../reducers/addressReducer';
import { STYLES } from '../Modal/model_styles';

class AddAddressModal extends Component {
    state = {
      handleSubmitClick: false,
    }
    onCloseRequest = () => {
      if (!this.state.handleSubmitClick) {
        this.props.hideModal();
      }
    }

  render() {
    return (
      <Modal
        paddingTop={STYLES.paddingTopStyle}
        overlayTop={0} 
        closeOnOverlayClick={true} 
        closeOnOutsideClick={false} 
        isOpened={true}  
        onClose={this.onCloseRequest}>
          <AddAddressForm 
            isDefault={true}
            onRemoveAddress={this.props.onRemoveAddress} 
            onCloseRequest={this.onCloseRequest}
          />
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    deliveryAddresses: addressReducer.getDeliveryAddresses(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      saveAddress: (address) => saveAddress(address),
      hideModal: () => dispatch(modal.hideModal()),
      addDeliveryAddress: (address) => dispatch(addressReducer.addDeliveryAddresses(address)),
      setDelivery: (addressIndex) => dispatch(addressReducer.setDelivery(addressIndex)),
      setPickup: (addressIndex) => dispatch(addressReducer.setPickup(addressIndex)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAddressModal);

// const ButtonsWrapperDiv = styled.div `
//   display: flex;
//   justify-content: space-between;
//   width: 255px;
// `;


              // {!this.state.isInputAddressActive && 
              //     <ButtonsWrapperDiv>
              //       <RaisedButton
              //         disabled={!this.isSubmitted()}
              //         onClick={this.handleSubmitClick}
              //         backgroundColor={`#` + this.props.secondaryColor}
              //         labelColor="#FFF"
              //         label="Cancel"
              //         style={styles.submitBtn}
              //       />
              //       <RaisedButton
              //         disabled={!this.isSubmitted()}
              //         onClick={this.handleSubmitClick}
              //         backgroundColor={`#` + this.props.secondaryColor}
              //         labelColor="#FFF"
              //         label="Save"
              //         style={styles.submitBtn}
              //       />
              //     </ButtonsWrapperDiv>
              // }


// WEBPACK FOOTER //
// ./src/components/AddAddressModal/AddAddressModal.jsx